import EditAdmin from './component'

export default EditAdmin
